<template>
  <div class="pbox box sticky float_sdw">
    <div class="pbox__inner">
      <textarea-autosize
        placeholder="メモやURLを保存しよう"
        ref="postText"
        v-model="text"
        :min-height="30"
        :max-height="600"
        class="pbox__txt"
        aria-label="add element to the pod"
      />
      <div class="pbox__act">
        <div class="pbox__pd__box" v-if="mode !== 'single'">
          <select class="pbox__pd" name="potadd" aria-label="select a pot add to." v-model="potId">
            <option :value="pot.id" v-for="(pot, i) in potlist" :key="i">
              {{pot.title}}
            </option>
          </select>
        </div>
        <button class="btn flx_ctr" :disabled="text === '' || potlist.length === 0" aria-label="submit adding a context to the pot." v-on:click="addDetail()">投稿</button>
      </div>
    </div>
  </div>
</template>

<script>
import { mapActions } from 'vuex';
import { exportDB } from "dexie-export-import";
import { uuid } from 'vue-idb'
import Gdfs from "gdrive-fs";
import dayjs from 'dayjs'

export default {
  data() {
    return {
      potlist: [],
      text: '',
      potId: '',
    }
  },
  props:['mode', 'id', 'sharetxt'],
  created(){
    if(this.sharetxt) this.text += this.sharetxt
    this.getList()
  },
  mounted(){
    if(this.text !== '') this.$refs.postText.$el.focus()
  },
  watch: {
    '$route' () {
      this.potId = ''
      this.getList()
    }
  },
  methods: {
    ...mapActions([
      'potDetailsAdd', 'toggleSpSlide'
    ]),
    getList: async function(){
      this.potlist = await this.$db.pots.orderBy('updated_at', 'dsec').desc().toArray()
      .then((data)=>{
        return data
      })
      if(this.mode !== 'single'){
        if(this.potlist.length > 0){
          if(this.potId === ''){
            this.potId = this.potlist[0].id
          }
        }
      }else{
        this.potId = this.id
      }
    },
    addDetail: async function(){
      const details = await this.$db.potDetails.where({potId: this.potId}).sortBy('order')

      this.mesPara = {};
      this.mesPara.icon = 'spinner';
      this.mesPara.message = 'ローカルDBに保存しています';
      this.$emit('setMessage', this.mesPara);

      await this.potDetailsAdd({
        id: uuid(),
        potId: this.potId,
        text: this.text,
        status: 1,
        order: details.length + 1,
        created_at: dayjs().format('YYYY-MM-DDTHH:mm:ssZ') ,
        updated_at: dayjs().format('YYYY-MM-DDTHH:mm:ssZ')
      }).then(async()=>{
          await this.$db.pots.update(this.potId, {updated_at: dayjs().format('YYYY-MM-DDTHH:mm:ssZ')})
          this.text = ''
          this.$emit('refresh', this.id);
          
          this.mesPara.message = 'ローカルDBに保存しました';
          this.$emit('setMessage', this.mesPara);

          this.mesPara.message = 'クラウドに保存しています...';
          this.$emit('setMessage', this.mesPara);
          // // GDに同期
          await this.gdApiInit();
          await this.gdCheckSignin();
          if(this.isGdSignin){
            await this.setCloudDataset();
            await this.gdUpload();
          }
          this.mesPara = false;
          await this.$emit('setMessage', this.mesPara);
      })
      // cloudと同期
      // await this.syncCloud();

      // if(this.$route.name === 'PotDetail' && this.$route.params.id === this.potId){
      //   this.$router.go({path: this.$router.currentRoute.path, force: true});
      // }else{
      //   this.toggleSpSlide(true)
      //   this.$router.push({ name: 'PotDetail', params: {id: this.potId}})
      // }

    },
    syncCloud: async function() {
      const apiParams = {};
      apiParams.clientId =
        "181186523944-rpmtnlr14lbtheirm6q5i6jgvil1ulsp.apps.googleusercontent.com";
      apiParams.clientSecret = "sL8WHq8Bs3FKDljPRdX42Q6n";
      apiParams.discoveryDocs = [
        "https://www.googleapis.com/discovery/v1/apis/drive/v3/rest"
      ];
      apiParams.scope = ["https://www.googleapis.com/auth/drive.appdata"].join(
        " "
      );
      await Gdfs.loadApi(apiParams);

      // localDBの日付チェック
      const dbupdate = await this.$db.pots
        .orderBy("updated_at")
        .desc()
        .toArray();
      const localLastUpdate = dbupdate.length > 0 ? dbupdate[0].updated_at : null;

      // gdriveの日付チェック
      const params = {
        spaces: "appDataFolder",
        fields: "nextPageToken, files(id, name, modifiedTime)",
        pageSize: 100,
        orderBy: "modifiedTime desc"
      };

      const dir = await Gdfs.getFileList(params);
      let fileStat = '';
      if (dir.files.length === 0) {
        fileStat = await Gdfs.createFile("appDataFolder", "potly_db.json");
      } else {
        fileStat = dir.files[0];
      }

      // ローカルの方が未来なら同期
      if(dayjs(localLastUpdate).valueOf() > dayjs(fileStat.modifiedTime).valueOf()){
        console.log('potを追加したので、クラウド同期します');
        const blob = await exportDB(this.$db);
        await Gdfs.updateFile(fileStat.id, "application/json", blob);
      }
    },
  }
}
</script>

<style lang="scss">
.pbox{
  margin-bottom: 32px;
  padding: 8px;
  border-radius: 8px;
  &.sticky{
    position: sticky;
    top: 0;
    z-index: 1;
  }
  .pbox__inner{
    border: 2px dashed #8ef5ab;
    border-radius: 3px;
    padding: 8px;
    .pbox__txt{
      width: 100%;
      min-height: 80px;
      max-height: 100vh;
      white-space: normal;
      vertical-align: top;
      resize: vertical;
      @media screen and (max-width: 648px){
        min-height: 30px;
      }
      &:focus{
        outline: none;
      }
    }
    .pbox__act{
      width: 100%;
      margin-top: 12px;
      .pbox__pd__box{
        position: relative;
        &:before {
          content: '';
          width: 0;
          height: 0;
          border-style: solid;
          border-width: 10px 6px 0 6px;
          border-color: #333 transparent transparent transparent;
          position: absolute;
          top: 12px;
          left: 8px;
          z-index: 2;
          border-radius: 2px;
        }
      }
      .pbox__pd{
        text-indent: 1em;
        overflow: hidden;
        font-size: 1rem;
        width: 100%;
        margin-bottom: 12px;
        background: #EEE;
        padding: 4px 12px;
        border-radius: 6px;
        position: relative;
        line-height: 24px;
        font-size: 16px;
      }
    }
  }
}
@media screen and (max-width: 648px){
  .pbox{
    &.sticky:focus-within{
      bottom: calc(.8rem + 8px);
    }
  }
  .pbox__inner{
    max-height: 46px;
    transition: all .4s ease 0s;
    overflow: hidden;
    &:focus-within{
      max-height: 100vh;
    }
  }
}
</style>
